import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mountains",
  "use": "mountains-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"mountains\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.4289 7.49127C15.0419 6.83624 14.0941 6.83624 13.7071 7.49127L9.95984 13.8328L8.31121 11.5247C7.91239 10.9663 7.08256 10.9663 6.68374 11.5247L3.18803 16.4187C2.71527 17.0805 3.18839 17.9999 4.00176 17.9999H12.9364L12.9364 17.9999H19.8861C20.6604 17.9999 21.141 17.1578 20.7471 16.4912L15.4289 7.49127Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol